import { render, staticRenderFns } from "./F10Company.vue?vue&type=template&id=ecb849be&scoped=true"
import script from "./F10Company.vue?vue&type=script&lang=js"
export * from "./F10Company.vue?vue&type=script&lang=js"
import style0 from "./F10Company.vue?vue&type=style&index=0&id=ecb849be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb849be",
  null
  
)

export default component.exports